import React from 'react';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Title,
    Container,
    ButtonGroup,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import validate from './validations';

class FindPollingStationForm extends React.Component {
    constructor() {
        super();
        this.state = {
            valid: false
        };
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <Title>Address Lookup</Title>
                <MultipleGroupFull>
                    <ReactGoogleAutocomplete
                        formName={['findPollingStationForm', 'google_autocomplete']}
                        fields={['address_components', 'formatted_address']}
                        types={['address']}
                        componentRestrictions={{ country: 'US' }}
                        setValidState={this.setValidState.bind(this)}
                        typeToReturn={'object'}
                    />
                </MultipleGroupFull>
                <ButtonGroup
                    style={{
                        marginTop: '10px'
                    }}
                    isAddressSubmitting={this.props.isAddressSubmitting}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            className="submitButton"
                            disabled={this.props.invalid || !this.state.valid}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </Container>
        );
    }
}

FindPollingStationForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isAddressSubmitting: PropTypes.bool
};

export default compose(
    connect(state => ({
        initialValues: {
            address: state.cachedFormData.address || ''
        }
    })),
    reduxForm({
        form: 'findPollingStationForm',
        destroyOnUnmount: false,
        validate
    })
)(FindPollingStationForm);
